import symbol from '@/data/currency.js'

export default {
  // format (data) {
  //   let currency = new Intl.NumberFormat('en-US', {
  //     style: 'currency',
  //     currency: 'USD',
  //   })
  //   if (data.code === 'INR') {
  //     currency = new Intl.NumberFormat('en-IN', {
  //       style: 'currency',
  //       currency: 'INR',
  //     })
  //   }
  //   return currency.format(data.val)
  // }
  format (data, useSymbol = true) {
    let locale = 'en-US'
    let options = {
      style: 'currency',
      currency: data.code,
      currencyDisplay: 'code'
    }

    let currency = new Intl.NumberFormat(locale, options)
    let newVal = currency.format(data.val).replace(data.code, "").trim()
    return useSymbol ? `${symbol[data.code]}${newVal}` : newVal
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/currency.js